/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Tour } from 'src/app/_model/tour';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class TourDaoService implements Resetable {
  public abstract saveTours(tours: Tour[]): Promise<void>;
  public abstract getTours(): Promise<Tour[]>;
  public abstract reset():Promise<void>;
  public abstract clear():Promise<void>;
}
